/* eslint-disable react-hooks/exhaustive-deps */
import { Select, Tabs } from 'antd';
import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import useQuery from '../../../util/useQuery';
import DsRequestForm from './DsRequestForm';
import ThankYou from './ThankYou';
import { useDsRequestContext } from '../context';
import UserManagementService from '../../../services/UserManagement.service';
import UserService from '../../../services/UserService';
import DataInventoryService from '../../../services/DataInventory.service';
import { ROUTER } from '../../../constants/router';
import GlobalService from '../../../services/Global.service';

const { TabPane } = Tabs;

const Header = ({ domainSelection, setDomainSelection, values }) => {
    const UIContext = useDsRequestContext();
    const UIProps = useMemo(() => {
        return {
            value: UIContext.value,
            setValue: UIContext.setValue,
            previewLang: UIContext.previewLang,
            setPreviewLang: UIContext.setPreviewLang,
            setCompanyId: UIContext.setCompanyId,
        };
    }, [UIContext]);

    const navigate = useNavigate();
    const id = UserService.getUi();
    const params = useQuery();
    const { Option } = Select;
    const { t } = useTranslation();

    const [domainList, setDomainList] = useState([]);
    const [companyName, setCompanyName] = useState();
    const [codeCopy, setCodeCopy] = useState(
        `${window.location.origin}/${UIProps.previewLang}/ds-request-form/${domainSelection}`
    );

    const getDomain = async () => {
        try {
            const { data } = await GlobalService.getDomain();
            // setDomainList(data?.resultData);
            const item = data?.resultData;
            setDomainList(item?.filter((e) => e !== null) || []);
        } catch (error) {
            console.log(error);
        }
    };

    const getCompanyList = (value) => {
        DataInventoryService.getCompanyList().then((res) => {
            const item = res?.data?.resultData;
            const result = item?.filter((res) => res?.id === value);
            setCompanyName(result[0]?.companyName);
        });
    };

    const getUserDetail = async () => {
        try {
            const { data } = await UserManagementService.getUserDetail(id);
            const item = data?.resultData;
            getCompanyList(item?.companyId);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getDomain();
        getUserDetail();
    }, []);

    useEffect(() => {
        let script = codeCopy.replace(
            /window.gDSAR.init\('([a-zA-Z0-9 ]+)'\)/,
            `window.gDSAR.init('${
                domainSelection || 'Please Select Domain First'
            }')`
        );
        script = script.replace(
            /lang="([A-Z]+)"/,
            `lang="${UIProps?.previewLang === 'TH' ? 'TH' : 'EN'}"`
        );
        setCodeCopy(script);
        setCodeCopy(
            `${window.location.origin}/${UIProps.previewLang}/ds-request-form/${domainSelection}`
        );
    }, [UIProps?.previewLang, domainSelection]);

    const domainName = domainList.find(
        (domain) => domain?.domainId === domainSelection
    );

    return (
        <div className="space-y-6 mt-6">
            <div className="bg-white p-5 rounded-md">
                <div className="grid grid-cols-3 gap-x-10">
                    <div className="flex flex-col space-y-1">
                        <div className="text-[#65707A] text-xs font-semibold">
                            {t('Domain')}
                        </div>
                        <Select
                            className=" w-full"
                            placeholder={t('Select Domain')}
                            size="large"
                            onChange={(e) => {
                                setDomainSelection(e);
                                const company = domainList.find(
                                    (d) => d.domainId === e
                                );
                                if (company) {
                                    UIProps.setCompanyId(company.companyId);
                                }
                            }}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.children ?? '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                        >
                            {domainList?.map((res) => (
                                <Option
                                    key={res?.domainId}
                                    value={res?.domainId}
                                >
                                    {res?.domainName}
                                </Option>
                            ))}
                        </Select>
                    </div>
                    <div className="flex flex-col space-y-1">
                        <div className="text-[#65707A] text-xs font-semibold">
                            {t('Company')}
                        </div>
                        <div className="text-base font-semibold">
                            <div>{companyName || '-'}</div>
                        </div>
                    </div>
                    <div className="flex flex-col space-y-1">
                        <div className="grid grid-cols-1 space-y-1">
                            <div className="text-[#65707A] text-xs font-semibold">
                                {t('Updated Date/by')}
                            </div>
                            <div className="text-base font-semibold">
                                <div>
                                    {values?.updateByFullname
                                        ? values?.updateByFullname
                                        : '-'}
                                </div>
                                <div>
                                    {values?.updateDate
                                        ? moment(values?.updateDate).format(
                                              'DD/MM/YYYY HH:mm'
                                          )
                                        : '-'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Tabs
                className="tabs bg-white p-5 rounded-md"
                onChange={(key) => {
                    navigate(`${ROUTER.DS_360.DS_REQUEST_FORM}?tab=${key}`);
                }}
                activeKey={params.get('tab') || '1'}
                // renderTabBar={renderTabBar}
            >
                <TabPane tab={t('DS Request Form')} key={1}>
                    <DsRequestForm
                        domainName={domainName?.domainName}
                        codeCopy={codeCopy}
                        domainSelection={domainSelection}
                        setDomainSelection={setDomainSelection}
                        values={values}
                    />
                </TabPane>
                <TabPane tab={t('Rights Description')} key={2}>
                    <DsRequestForm
                        domainName={domainName?.domainName}
                        codeCopy={codeCopy}
                        domainSelection={domainSelection}
                        setDomainSelection={setDomainSelection}
                        values={values}
                    />
                </TabPane>
                <TabPane tab={t('Thank you page')} key={3}>
                    <ThankYou
                        domainName={domainName?.domainName}
                        codeCopy={codeCopy}
                        domainSelection={domainSelection}
                        setDomainSelection={setDomainSelection}
                        values={values}
                    />
                </TabPane>
            </Tabs>
        </div>
    );
};

export default Header;
